function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="14" height="20" viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#A8ACBB" fillRule="evenodd"><circle cx="2" cy="2" r="2" /><circle cx="12" cy="2" r="2" /><circle cx="2" cy="10" r="2" /><circle cx="12" cy="10" r="2" /><circle cx="2" cy="18" r="2" /><circle cx="12" cy="18" r="2" /></g></svg>;
});